import { setHasReportedAppLoaded } from '../store/app-loaded/app-loaded-actions';

export const appLoaded = () => (dispatch) => {
  dispatch(setHasReportedAppLoaded());
};
